import type { AnnotationStoreT, FrameStateT } from '../../labelling/types';
export function buildAnnotationFrameMap(frames: FrameStateT[], field: 'annotationMLStore' | 'annotationConsensusStore'): Map<number, AnnotationStoreT> {
  const map = new Map<number, AnnotationStoreT>();
  frames.forEach((frame, index) => {
    const store = frame[field];
    if (store && Object.keys(store).length > 0) {
      map.set(index, store);
    }
  });
  return map;
}